import React from "react";
import { Box, Typography, makeStyles } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import vaultCTA from "../../../Main/Landing/images/vaultCTA.png";

const useStyles = makeStyles((theme) => ({
    ctaSection: {
        padding: '0 5% 60px',
        backgroundColor: '#111111',
        display: 'flex',
        justifyContent: 'center',
        [theme.breakpoints.down('sm')]: {
            padding: '24px 5%',
        }
    },
    ctaContainer: {
        maxWidth: 1314,
        width: '100%',
        margin: '0 auto',
        background: 'linear-gradient(90deg, #CF819D, #FFB8D1, #CF819D)',
        borderRadius: '16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 60px',
        overflow: 'hidden',
        position: 'relative',
        minHeight: 367,
        boxSizing: 'border-box',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            padding: '40px 24px 0',
            textAlign: 'center',
            minHeight: 'auto',
        }
    },
    ctaContent: {
        maxWidth: '490px',
        zIndex: 1,
        padding: '60px 0',
        [theme.breakpoints.down('sm')]: {
            maxWidth: '100%',
            padding: '0',
            marginBottom: '40px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        }
    },
    ctaTitle: {
        fontFamily: '"Cormorant Garamond", serif',
        fontSize: '52px',
        fontWeight: 400,
        lineHeight: '100%',
        color: '#0c0a09',
        marginBottom: '16px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '36px',
            lineHeight: '100%',
        }
    },
    desktopBreak: {
        display: 'inline',
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        }
    },
    mobileBreak: {
        display: 'none',
        [theme.breakpoints.down('sm')]: {
            display: 'inline',
        }
    },
    ctaSubtitle: {
        fontSize: '18px',
        fontWeight: 400,
        color: '#0c0a09',
        lineHeight: '27px',
        marginBottom: '24px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '14px',
            lineHeight: '140%',
        }
    },
    ctaButton: {
        height: '48px',
        backgroundColor: '#FD3C84',
        color: '#ffffff',
        border: 'none',
        borderRadius: '6px',
        padding: '0 32px',
        fontSize: '16px',
        fontWeight: 500,
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        fontFamily: '"Roboto", sans-serif',
        '&:hover': {
            backgroundColor: '#ff4081',
            transform: 'translateY(-1px)',
        },
        [theme.breakpoints.down('sm')]: {
            height: "38px",
            fontSize: '14px',
        }
    },
    ctaImageContainer: {
        position: 'absolute',
        right: '40px',
        bottom: '-20px',
        width: '540px',
        height: '420px',
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'center',
        [theme.breakpoints.down('md')]: {
            width: '400px',
            right: 0,
        },
        [theme.breakpoints.down('sm')]: {
            position: 'relative',
            right: 0,
            bottom: 0,
            width: '100%',
            height: 'auto',
            marginTop: '20px',
        }
    },
    ctaImage: {
        width: '100%',
        height: '100%',
        objectFit: 'contain',
        objectPosition: 'bottom right',
        display: 'block',
        [theme.breakpoints.down('sm')]: {
            maxWidth: '100%',
            width: '100%',
            objectPosition: 'bottom center',
        }
    }
}));

export const VaultCTASection: React.FC = () => {
    const classes = useStyles();
    const history = useHistory();

    return (
        <Box className={classes.ctaSection}>
            <Box className={classes.ctaContainer}>
                <Box className={classes.ctaContent}>
                    <Typography variant="h2" className={classes.ctaTitle}>
                        Ready to Unlock <br className={classes.mobileBreak} />The<br className={classes.desktopBreak} /> Vault?
                    </Typography>
                    <Typography className={classes.ctaSubtitle}>
                        Join in minutes. Cancel any time. Discretion, always included.
                    </Typography>
                    <button className={classes.ctaButton} onClick={() => history.push('/member-onboarding-step')}>
                        Become A Member
                    </button>
                </Box>
                <Box className={classes.ctaImageContainer}>
                    <img src={vaultCTA} alt="Sugar Cribs App" className={classes.ctaImage} />
                </Box>
            </Box>
        </Box>
    );
};
